/* Efnisupplysingar i hurdaskilta-configurator.
   1) Skiptir efnisrodinni i tvo flokka: AKRYL (4) og MALMAR (3).
   2) Baetir vid upplysingablokk FYRIR OFAN efnisrodina: nafn, verd fra og lysing.
   Les valid efni ur .mrail-item.active / .mat.active og verd ur [data-mat-price]. */
(function(){
  var root=document.querySelector('[data-hurda]'); if(!root) return;
  var NAME={gold:'Akrýl gull',silver:'Akrýl silfur',black:'Akrýl svart',white:'Akrýl hvítt',aluminum:'Ál svart',steel:'Burstað stál',brass:'Messing'};
  var AKRYL='Tvílitt akrýl, 1,6 mm. UV-varið útiefni sem þolir íslenskt veðurfar. Fæst ferhyrnt eða sporöskjulaga.';
  var INFO={
    gold:AKRYL, silver:AKRYL, black:AKRYL, white:AKRYL,
    aluminum:'Ál, 1 mm, með svörtu yfirborði sem er grafið af, svo stafirnir koma fram í áli. Aðeins ferhyrnt.',
    steel:'316 stál, 1 mm, burstað. Stafirnir eru svartir eða grafnir í stálið, og fyrir grafið stál má velja sýruþvott sem gefur betri endingu. Aðeins ferhyrnt.',
    brass:'Messing, 1 mm, burstað. Stafirnir eru grafnir, tón í tón. Varnarefni fæst sem valkostur fyrir messing. Það dökknar fallega með tímanum. Aðeins ferhyrnt.'
  };
  var AKR=['gold','silver','black','white'];

  /* ---- 1. Tveir flokkar i efnisrodinni ---- */
  function group(){
    var track=root.querySelector('.mrail .mrail-track');
    if(!track||root.querySelector('.mrail-groups')) return;
    var items=Array.prototype.slice.call(track.querySelectorAll('[data-mat]'));
    if(items.length<7) return;
    var wrap=document.createElement('div'); wrap.className='mrail-groups';
    [['Akrýl',4],['Málmar',3]].forEach(function(g,gi){
      var col=document.createElement('div'); col.className='mrail-group';
      var cap=document.createElement('div'); cap.className='mrail-gcap'; cap.textContent=g[0];
      var t=document.createElement('div'); t.className='mrail-track mrail-track-'+g[1];
      items.filter(function(it){ return (AKR.indexOf(it.getAttribute('data-mat'))>=0)===(gi===0); })
           .forEach(function(it){ t.appendChild(it); });
      col.appendChild(cap); col.appendChild(t); wrap.appendChild(col);
    });
    track.parentNode.insertBefore(wrap,track);
    track.parentNode.removeChild(track);
  }

  /* ---- 2. Upplysingablokk fyrir ofan efnisrodina ---- */
  function block(){
    var el=document.createElement('div'); el.className='matinfo';
    el.innerHTML='<div class="matinfo-row"><span class="matinfo-name" data-mat-info-name></span><span class="matinfo-price" data-mat-info-price></span></div>'
      +'<div class="matinfo-text" data-mat-info-text></div>';
    return el;
  }
  function mount(){
    var mrail=root.querySelector('.mrail');
    if(mrail&&!mrail.querySelector('.matinfo')){
      var g=mrail.querySelector('.mrail-groups')||mrail.firstChild;
      mrail.insertBefore(block(),g);
    }
    var mg=root.querySelector('.mat-block .mat-groups')||root.querySelector('.mat-block .mrail-groups');
    if(mg&&!root.querySelector('.mat-block .matinfo')) mg.parentNode.insertBefore(block(),mg);
  }

  function set(sel,txt){ root.querySelectorAll(sel).forEach(function(el){ if(el.textContent!==txt) el.textContent=txt; }); }
  function render(){
    var a=root.querySelector('.mrail-item.active[data-mat]')||root.querySelector('.mat.active[data-mat]');
    var k=a?a.getAttribute('data-mat'):null;
    if(!k||!INFO[k]) return;
    var p=root.querySelector('[data-mat-price="'+k+'"]');
    var pv=p?(p.textContent||'').trim():'';
    set('[data-mat-info-name]',NAME[k]||'');
    set('[data-mat-info-text]',INFO[k]);
    set('[data-mat-info-price]',pv?('Verð frá '+pv+' kr.'):'');
  }

  function init(){
    group(); mount(); render();
    root.querySelectorAll('[data-mat]').forEach(function(b){ b.addEventListener('click',function(){ setTimeout(render,40); }); });
    if(window.MutationObserver){
      var pend=null;
      var mo=new MutationObserver(function(){ if(pend) return; pend=setTimeout(function(){ pend=null; render(); },50); });
      root.querySelectorAll('[data-mat],[data-mat-price]').forEach(function(el){
        mo.observe(el,{attributes:true,attributeFilter:['class'],childList:true,characterData:true,subtree:true});
      });
    }
    [300,900,2000,3500].forEach(function(t){ setTimeout(render,t); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
